import { ParsedUrlQuery } from 'querystring';

import { paramsOutsideFilters } from 'consts/filters';
import ContactConfig from 'types/ContactConfig';
import keysOf from 'utils/keysOf';
import { IntlShape } from 'utils/intl';
import omit from 'utils/omit';

import messages from './Search.messages';

export const getMetaDescription = (
  intl: IntlShape,
  contact: ContactConfig,
  title: string,
  query: ParsedUrlQuery
): string => {
  const serializedFilters = keysOf(
    omit(query, [...paramsOutsideFilters, 'product_type', 'manufacturer', 'series', 'product'])
  ).reduce((acc, key) => `${acc} - ${query[key]}`, '');
  return intl.formatMessage(messages.metaDescription, {
    filters: `${title}${serializedFilters}`,
    appName: contact.appName,
  });
};

export const getPageTitleAdditionalInfo = (intl: IntlShape, query: ParsedUrlQuery): string => {
  const pageInfo = query.page ? intl.formatMessage(messages.pageNo, { page: query.page }) : '';
  const onlyAvailableInfo = query.is_available ? intl.formatMessage(messages.onlyAvailable) : '';

  return [pageInfo, onlyAvailableInfo]
    .filter(Boolean)
    .map((info) => ` - ${info}`)
    .join('');
};
